module.exports = __webpack_public_path__ + "static/media/icon-supplies-bodysoap.f5097b72.svg";